import type { FormArray, FormControl } from '@angular/forms';

import type { Observable } from 'rxjs';

import type { FormGroupOf } from '@core/common-legacy';
import type { LanguageItem } from '@core/languages-types';
import type { LocationLanguageTranslation } from '@core/locations-data';
import type { Location } from '@core/locations-types';

export enum LocationDialogContext {
  Create = 'create',
  Edit = 'edit',
}

export type ManageLocationCtrlData = {
  id?: number;
  langCode?: string;
  jobLanguages?: string[];
  jobPrimaryLanguageCode?: string;
  goBackHandler?: () => void;
  saveHandler?: (createdLocationId: number) => void;
};

export type ManageLocationDialogData = {
  id?: number;
  goBackHandler?: () => void;
  saveHandler?: (createdLocationId: number) => void;
  location?: Location;
  fromJob?: boolean;
  updateLocation$?: Observable<Location>;
  close$?: Observable<boolean>;
  context: LocationDialogContext;
  defaultLanguage: string;
  availableLanguages: Array<LanguageItem & { isDefault: boolean }>;
  activeLanguage: string;
};

export type LocationForm = {
  translations: FormArray<FormGroupOf<LocationLanguageTranslation>>;
  countryCode: FormControl<string>;
  stateCode: FormControl<string>;
};
